interface EnvConfig {
  APP_NAME: string;
  APP_VERSION: string;
  API_URL: string;
  API_TIMEOUT: number;
  AUTH_TOKEN_KEY: string;
  AUTH_REFRESH_TOKEN_KEY: string;
  ENABLE_MOCK_API: boolean;
  ENABLE_ANALYTICS: boolean;
  SENTRY_DSN?: string;
  GOOGLE_ANALYTICS_ID?: string;
  BUILD_ENV: 'development' | 'production';
  GENERATE_SOURCEMAP: boolean;
}

const env: EnvConfig = {
  APP_NAME: process.env.REACT_APP_NAME || 'VF Trade',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  API_TIMEOUT: Number(process.env.REACT_APP_API_TIMEOUT || 30000),
  AUTH_TOKEN_KEY: process.env.REACT_APP_AUTH_TOKEN_KEY || 'vf_token',
  AUTH_REFRESH_TOKEN_KEY: process.env.REACT_APP_AUTH_REFRESH_TOKEN_KEY || 'vf_refresh_token',
  ENABLE_MOCK_API: process.env.REACT_APP_ENABLE_MOCK_API === 'true',
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  BUILD_ENV: (process.env.REACT_APP_BUILD_ENV || 'development') as 'development' | 'production',
  GENERATE_SOURCEMAP: process.env.GENERATE_SOURCEMAP === 'true',
};

export default env;
